import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, filter, map, of } from 'rxjs';
import { StorageService } from 'src/app/_services/storage.service';
import { environment } from 'src/environments/environment';
const { API_URLBLAZE } = environment;

@Injectable({
  providedIn: 'root'
})

export class TransactionMasterService {

  constructor(private http: HttpClient, private storageService: StorageService, private router: Router) { }


  //Update Rule
  updateAMLRule(ruleData: any): Observable<any> {
    const url = `${API_URLBLAZE}/transaction/transaction-rules`;
    return this.http.post(url, ruleData).pipe(catchError(this.handleError()));
  }

  //Get AML Rule 
  getAMLRule(id: any) {
    const url = `${API_URLBLAZE}/transaction/transaction-rules/${id}`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  //Delete Aml Rule 
  deleteAmlRule(deleteData: any) {
    const url = `${API_URLBLAZE}/transaction/transaction-rules`;
    return this.http.delete(url, {
      body: deleteData
    }).pipe(catchError(this.handleError()));
  }

  //Get Email Config 
  getEmailConfig(userType: any) {
    const url = `${API_URLBLAZE}/transaction/aml-email-config?userType=${userType}`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  //Add Email Config 
  AddEmailConfig(emailForm: any) {
    const url = `${API_URLBLAZE}/transaction/aml-email-config`;
    return this.http.post(url, emailForm).pipe(catchError(this.handleError()));
  }

  //Delete Email Config 
  deleteEmailConfig(id: any) {
    const url = `${API_URLBLAZE}/transaction/aml-email-config/${id}`;
    return this.http.delete(url).pipe(catchError(this.handleError()));
  }
  //Get OnHold Transaction Report List with Pagination
  getVatInvoiceReportScheduler(pageNumber: any, pageRecords: number, dateFrom: String, dateTo: String, merchantId: string, walletId: string, requestId: string, invoiceNumber: string, type: string) {
    var url = "";
    var filter = "";
    if (dateFrom != "" && dateFrom != null) {
      filter = filter + `&startPeriod=gte%3D${dateFrom}`;
    }
    if (dateTo != "" && dateTo != null) {
      filter = filter + `&endPeriod=lte%3D${dateTo}`;
    }
    if (merchantId != "" && merchantId != null) {
      filter = filter + `&merchantId=${merchantId}`
    }
    if (walletId != "" && walletId != null) {
      filter = filter + `&walletId=${walletId}`
    }

    if (requestId != "" && requestId != null) {
      filter = filter + `&requestId=${requestId}`
    }
    if (invoiceNumber != "" && invoiceNumber != null) {
      filter = filter + `&vatInvoiceNumber=${invoiceNumber}`
    }

    url = `${API_URLBLAZE}/transaction/vat-invoice/scheduled?page_size=${pageRecords}&page_no=${pageNumber}` + filter;
    // url = `http://localhost:8083/transaction/vat-invoice/scheduled?page_size=${pageRecords}&page_no=${pageNumber}` + filter;

    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  createVatRequest(data: any): Observable<any> {
    // const url = `http://localhost:8083/transaction/vat-invoice/create`;
    const url = `${API_URLBLAZE}/transaction/vat-invoice/create`;
    // console.log("Input request:", data);
    // console.log(url);
    return this.http.post(url, data).pipe(catchError(this.handleError()));
  }


  resetEmailRequest(invoiceNumber: any): Observable<any> {
    // const url = `http://localhost:8083/transaction/vat-invoice/email/${invoiceNumber}`;
    const url = `${API_URLBLAZE}/transaction/vat-invoice/email/${invoiceNumber}`;
    // console.log("Input request:", invoiceNumber);
    // console.log(url);
    return this.http.get(url).pipe(catchError(this.handleError()));

  }


  //Get OnHold Transaction Report List with Pagination
  getVatInvoiceReportRequested(pageNumber: any, pageRecords: number, dateFrom: String, dateTo: String, merchantId: string, walletId: string, requestId: string, invoiceNumber: string, type: string) {
    var url = "";
    var filter = "";
    console.log("Start date " + dateFrom + "end date " + dateTo);
    
    if (dateFrom != "" && dateFrom != null) {
      filter = filter + `&startPeriod=gte%3D${dateFrom}`;
    }
    if (dateTo != "" && dateTo != null) {
      filter = filter + `&endPeriod=lte%3D${dateTo}`;
    }

    if (merchantId != "" && merchantId != null) {
      filter = filter + `&merchantId=${merchantId}`
    }
    if (walletId != "" && walletId != null) {
      filter = filter + `&walletId=${walletId}`
    }
    if (requestId != "" && requestId != null) {
      filter = filter + `&requestId=${requestId}`
    }
    if (invoiceNumber != "" && invoiceNumber != null) {
      filter = filter + `&vatInvoiceNumber=${invoiceNumber}`
    }
    url = `${API_URLBLAZE}/transaction/vat-invoice/manual?page_size=${pageRecords}&page_no=${pageNumber}` + filter;
    // url = `http://localhost:8083/transaction/vat-invoice/manual?page_size=${pageRecords}&page_no=${pageNumber}` + filter;

    return this.http.get(url).pipe(catchError(this.handleError()));
  }


  //Get Transaction Report List All with Pagination
  getTransactionReportListAll(filterNew: any, userMobile: String, transactionType: String, status: String, dateFrom: string, dateTo: string, page_size: number, page_no: number, sort: string, columnName: string, column1: any, column2: any, column3: any) {
    console.log("Start date " + dateFrom + "end date " + dateTo);
    console.log("Txn Master :: productCode: " + filterNew.productCode);
    var url = "";
    var filter = "";
    const logicalConditionMap: any = {
      // "EqualsTo": "=",
      "NotEqualsTo": "ne%3D",
      "GreaterThanEqualTo": "gte%3D",
      "LessThanEqualTo": "lte%3D",
      "GreaterThan": "gt%3D",
      "LessThan": "lt%3D"
    };
    if (userMobile != "") {
      filter = filter + `&orCondition2=userMobile%2CreceiverMobile%3D${userMobile}`
    }
    if (transactionType != "" && transactionType != null) {
      filter = filter + `&transactionType=${transactionType}`
    }
    if (status != "" && status != null) {
      filter = filter + `&STATUS=in%3D${status}`
    }
    if (dateFrom != "" && dateTo != "") {
      filter = filter + `&createDate=gte%3D${dateFrom}%24lte%3D${dateTo}`
    }

    if (sort != "") {
      filter = filter + `&sort_dir=${sort}`
    }
    if (columnName != "") {
      filter = filter + `&sort_column=${columnName}`
    }

    if (filterNew.customerName && filterNew.customerName !== "") {
      filter += `&orCondition1=RECEIVER_NAME%2Csender%3D${filterNew.customerName}`;
    }

    if (filterNew.customerId && filterNew.customerId !== "") {
      filter += `&userId=${filterNew.customerId}`;
    }

    if (filterNew.currency && filterNew.currency !== "") {
      filter += `&currency=${filterNew.currency}`;
    }

    if (filterNew.amount !== null && filterNew.amount !== undefined && filterNew.amount !== "") {
      filter += `&totalAmount=${filterNew.amount}`;
    }

    if (filterNew.merchantName && filterNew.merchantName !== "") {
      filter += `&receiverName=${filterNew.merchantName}`;
    }

    if (filterNew.merchant && filterNew.merchant !== "") {
      filter += `&receiverId=${filterNew.merchant}`;
    }

    if (filterNew.merchantId && filterNew.merchantId !== "") {
      filter += `&merchantIdentifierId=${filterNew.merchantId}`;
    }

    if (filterNew.txnId && filterNew.txnId !== "") {
      filter = filter + `&txnId=${filterNew.txnId}`
    }

    if (filterNew.walletId && filterNew.walletId !== "") {
      filter = filter + `&walletId=${filterNew.walletId}`
    }

    if (filterNew.productCode && filterNew.productCode !== "") {
      filter = filter + `&productCode=${filterNew.productCode}`
    }
    
    if (column1.columnnName != "" && column1.searchText != "") {
      const condition = logicalConditionMap[column1.logicalCondition] ? logicalConditionMap[column1.logicalCondition] : "";
      filter = filter + `&${column1.columnnName}=${condition}${column1.searchText ? column1.searchText : null}`;
    }
    if (column2.columnnName != "" && column2.searchText != "") {
      const condition = logicalConditionMap[column2.logicalCondition] ? logicalConditionMap[column2.logicalCondition] : "";
      filter = filter + `&${column2.columnnName}=${condition}${column2.searchText ? column2.searchText : null}`;
    }
    if (column3.columnnName != "" && column3.searchText != "") {
      const condition = logicalConditionMap[column3.logicalCondition] ? logicalConditionMap[column3.logicalCondition] : "";
      filter = filter + `&${column3.columnnName}=${condition}${column3.searchText ? column3.searchText : null}`;
    }

    url = `${API_URLBLAZE}/transaction/transaction-report/customer?page_size=${page_size}&page_no=${page_no}` + filter;
    //   url = `http://localhost:8083/transaction/transaction-report/customer?page_size=${page_size}&page_no=${page_no}`+filter;

    console.log(url);
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  //Get OnHold Transaction Report List with Pagination
  getOnHoldTransactionReport(pageNumber: any, pageRecords: number, dateFrom: String, dateTo: String, customerId: string, transactionId: string, type: string) {
    var url = "";
    var filter = "";
    if (dateFrom != "" && dateTo != "") {
      filter = filter + `&createDate=gte%3D${dateFrom} 00:00:00%24lte%3D${dateTo} 23:59:59`
    }
    if (customerId != "" && customerId != null) {
      filter = filter + `&userId=${customerId}`
    }
    if (transactionId != "" && transactionId != null) {
      filter = filter + `&txnId=${transactionId}`
    }
    url = `${API_URLBLAZE}/transaction/transaction-report/on-hold?internalStatus=ON_HOLD&page_size=${pageRecords}&page_no=${pageNumber}&holdSourceList=${type}` + filter;
    //  url = `http://192.168.70.155:8083/transaction/transaction-report/on-hold?internalStatus=ON_HOLD&page_size=${pageRecords}&page_no=${pageNumber}`+filter;

    return this.http.get(url).pipe(catchError(this.handleError()));
  }


  getMerchantTransactionReport(filterNew: any, userMobile: String, transactionType: String, status: String, dateFrom: string, dateTo: string, page_size: number, page_no: number, sort: string, columnName: string, column1: any, column2: any, column3: any) {
    var url = "";
    var filter = "";
    const logicalConditionMap: any = {
      // "EqualsTo": "=",
      "NotEqualsTo": "ne%3D",
      "GreaterThanEqualTo": "gte%3D",
      "LessThanEqualTo": "lte%3D",
      "GreaterThan": "gt%3D",
      "LessThan": "lt%3D"
    };
    if(filterNew.productCode){
      filter = filter + `&productCode=${filterNew.productCode}`;
    }
    if (userMobile != "") {
      filter = filter + `&userMobile=${userMobile}`
    }
    if (transactionType != "" && transactionType != null) {
      filter = filter + `&transactionType=${transactionType}`
    }
    if (status != "" && status != null) {
      filter = filter + `&status=in%3D${status}`
    }
    if (dateFrom != "" && dateTo != "" && dateFrom != "" && dateTo != "") {
      filter = filter + `&createDate=gte%3D${dateFrom}%24lte%3D${dateTo}`
    }

    if (sort != "") {
      filter = filter + `&sort_dir=${sort}`
    }
    if (columnName != "") {
      filter = filter + `&sort_column=${columnName}`
    }

    if (filterNew.customerName && filterNew.customerName !== "") {
      filter += `&senderName=${filterNew.customerName}`;
    }

    if (filterNew.customerId && filterNew.customerId !== "") {
      filter += `&senderUserId=${filterNew.customerId}`;
    }

    if (filterNew.currency && filterNew.currency !== "") {
      filter += `&currency=${filterNew.currency}`;
    }

    if (filterNew.amount !== null && filterNew.amount !== undefined && filterNew.amount !== "") {
      filter += `&totalAmount=${filterNew.amount}`;
    }
    if (filterNew.merchantName && filterNew.merchantName !== "") {
      filter += `&receiverName=${filterNew.merchantName}`;
    }

    if (filterNew.merchant && filterNew.merchant !== "") {
      filter += `&receiverId=${filterNew.merchant}`;
    }

    if (filterNew.merchantId && filterNew.merchantId !== "") {
      filter += `&merchantIdentifierId=${filterNew.merchantId}`;
    }


    if (column1.columnnName != "" && column1.searchText != "") {
      const condition = logicalConditionMap[column1.logicalCondition] ? logicalConditionMap[column1.logicalCondition] : "";
      filter = filter + `&${column1.columnnName}=${condition}${column1.searchText ? column1.searchText : null}`;
    }
    if (column2.columnnName != "" && column2.searchText != "") {
      const condition = logicalConditionMap[column1.logicalCondition] ? logicalConditionMap[column1.logicalCondition] : "";
      filter = filter + `&${column2.columnnName}=${condition}${column2.searchText ? column2.searchText : null}`;
    }
    if (column3.columnnName != "" && column3.searchText != "") {
      const condition = logicalConditionMap[column1.logicalCondition] ? logicalConditionMap[column1.logicalCondition] : "";
      filter = filter + `&${column3.columnnName}=${condition}${column3.searchText ? column3.searchText : null}`;
    }

    url = `${API_URLBLAZE}/transaction/transaction-report/merchant?page_size=${page_size}&page_no=${page_no}` + filter;
    //   url = `http://localhost:8083/transaction/transaction-report/merchant?page_size=${page_size}&page_no=${page_no}`+filter;
    console.log(url);
    return this.http.get(url).pipe(catchError(this.handleError()));
  }


  // Update this method in TransactionMasterService
  getTransactionReportBackgroundExport(
    filterObj: any,
    customerMobile: string,
    transactionType: string,
    status: string,
    dateFrom: string,
    dateTo: string,
    page_size: number,
    page_no: number,
    sort: string,
    columnName: string,
    column1: any,
    column2: any,
    column3: any,
    isMerchantReport: boolean = false // Added parameter for merchant report logic
  ) {

    let url;
    if (isMerchantReport) {
      url = `${API_URLBLAZE}/transaction/transaction-report/merchant/export`;

    }
    else {
      url = `${API_URLBLAZE}/transaction/transaction-report/customer/export`;

    }
    let queryParams = [];

    // Add customer mobile if provided
    if (customerMobile && customerMobile !== "") {
      queryParams.push(`orCondition2=userMobile,receiverMobile=${customerMobile}`);
    }

    // Add transaction type if provided
    if (transactionType && transactionType !== "ALL" && transactionType !== "") {
      queryParams.push(`transactionType=${transactionType}`);
    }

    // Add status if provided
    if (status && status !== "ALL" && status !== "") {
      queryParams.push(`status=in=${status}`);
    }

    // Add date range if both dates are provided and they contain actual values
    if (dateFrom && dateTo &&
      dateFrom !== "" &&
      dateTo !== "" &&
      dateFrom !== " 00:00:00" &&
      dateTo !== " 23:59:59") {
      queryParams.push(`createDate=gte=${dateFrom}$lte=${dateTo}`);
    }

    // Add sorting parameters
    if (sort && sort !== "") {
      queryParams.push(`sort_dir=${sort}`);
    }

    if (columnName && columnName !== "") {
      queryParams.push(`sort_column=${columnName}`);
    }

    // Removed pagination parameters (page_size and page_no)

    // Add filter parameters
    if (filterObj.customerName && filterObj.customerName !== "") {
      queryParams.push(`orCondition1=RECEIVER_NAME,sender=${filterObj.customerName}`);
    }

    if (filterObj.customerId && filterObj.customerId !== "") {
      queryParams.push(`orCondition3=senderUserId,receiverId=${filterObj.customerId}`);
    }

    if (filterObj.currency && filterObj.currency !== "") {
      queryParams.push(`currency=${filterObj.currency}`);
    }

    if (filterObj.amount && filterObj.amount.toString() !== "") {
      queryParams.push(`totalAmount=${filterObj.amount}`);
    }

    if (filterObj.merchantName && filterObj.merchantName !== "") {
      queryParams.push(`receiverName=${filterObj.merchantName}`);
    }

    if (filterObj.merchant && filterObj.merchant !== "") {
      queryParams.push(`receiverId=${filterObj.merchant}`);
    }

    if (filterObj.merchantId && filterObj.merchantId !== "") {
      queryParams.push(`merchantIdentifierId=${filterObj.merchantId}`);
    }

    if (filterObj.orderId && filterObj.orderId !== "") {
      queryParams.push(`merchantReferenceId=${filterObj.orderId}`);
    }

    if (filterObj.txnId && filterObj.txnId !== "") {
      queryParams.push(`txnId=${filterObj.txnId}`);
    }

    if (filterObj.walletId && filterObj.walletId !== "") {
      queryParams.push(`walletId=${filterObj.walletId}`);
    }

    if (filterObj.productCode && filterObj.productCode !== "") {
      queryParams.push(`productCode=${filterObj.productCode}`);
    }

    // Add column filters
    const logicalConditionMap: any = {
      "NotEqualsTo": "ne=",
      "GreaterThanEqualTo": "gte=",
      "LessThanEqualTo": "lte=",
      "GreaterThan": "gt=",
      "LessThan": "lt="
    };

    if (column1.columnnName && column1.searchText && column1.columnnName !== "" && column1.searchText !== "") {
      const condition = logicalConditionMap[column1.logicalCondition] || "";
      queryParams.push(`${column1.columnnName}=${condition}${column1.searchText}`);
    }

    if (column2.columnnName && column2.searchText && column2.columnnName !== "" && column2.searchText !== "") {
      const condition = logicalConditionMap[column2.logicalCondition] || "";
      queryParams.push(`${column2.columnnName}=${condition}${column2.searchText}`);
    }

    if (column3.columnnName && column3.searchText && column3.columnnName !== "" && column3.searchText !== "") {
      const condition = logicalConditionMap[column3.logicalCondition] || "";
      queryParams.push(`${column3.columnnName}=${condition}${column3.searchText}`);
    }

    // Build the final URL
    if (queryParams.length > 0) {
      url += '?' + queryParams.join('&');
    }

    console.log('Background export URL:', url);

    return this.http.get(url).pipe(catchError(this.handleError()));
  }
  //Get Wallet Ledger Report List All with Pagination
  getWalletLedgerReportListAll(userMobile: String, transactionType: String, walletId: String, dateFrom: string, dateTo: string, page_size: number, page_no: number, sort: string, columnName: string, transactionId: string, userType: string, originalTxnId?: string) {
    var url = "";
    var filter = "";
    if (userMobile != "" && userMobile != undefined) {
      filter = filter + `&mobileNumber=${userMobile}`
    }
    if (transactionType != "" && transactionType != null && transactionType != undefined) {
      filter = filter + `&txnType=${transactionType}`
    }
    if (transactionId != "" && transactionId != null && transactionId != undefined) {
      filter = filter + `&txnId=${transactionId}`
    }
    if (walletId != "" && walletId != null && walletId != undefined) {
      filter = filter + `&walletId=${walletId}`
    }
    if (originalTxnId != "" && originalTxnId != null && originalTxnId != undefined) {
      filter = filter + `&originalTxnId=${originalTxnId}`
    }
    if (sort != "") {
      filter = filter + `&sort_dir=${sort}`
    }
    if (columnName != "") {
      filter = filter + `&sort_column=${columnName}`
    }
    if (dateFrom != "" && dateTo != "") {
      filter = filter + `&dateTime=gte%3D${dateFrom}%24lte%3D${dateTo}`
    }
    filter = filter + `&userType=${userType}`

    url = `${API_URLBLAZE}/transaction/transaction-report/wallet-ledger?page_size=${page_size}&page_no=${page_no}` + filter;
    //   url = `http://localhost:8083/transaction/transaction-report/wallet-ledger?page_size=${page_size}&page_no=${page_no}`+filter;
    console.log(url);
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  getWalletLedgerReportBackgroundExport(userMobile: String, transactionType: String, dateFrom: string, dateTo: string, page_size: number, page_no: number, sort: string, columnName: string, transactionId: string, userType: string, originalTxnId?: string) {
    var url = "";
    var filter = "";
    if (userMobile != "" && userMobile != undefined) {
      filter = filter + `&mobileNumber=${userMobile}`
    }
    if (transactionType != "" && transactionType != null && transactionType != undefined) {
      filter = filter + `&txnType=${transactionType}`
    }
    if (transactionId != "" && transactionId != null && transactionId != undefined) {
      filter = filter + `&txnId=${transactionId}`
    }
    if (originalTxnId != "" && originalTxnId != null && originalTxnId != undefined) {
      filter = filter + `&originalTxnId=${originalTxnId}`
    }
    if (sort != "") {
      filter = filter + `&sort_dir=${sort}`
    }
    if (columnName != "") {
      filter = filter + `&sort_column=${columnName}`
    }
    if (dateFrom != "" && dateTo != "") {
      filter = filter + `&dateTime=gte%3D${dateFrom}%24lte%3D${dateTo}`
    }
    filter = filter + `&userType=${userType}`
    // url = `http://localhost:8083/transaction/transaction-report/wallet-ledger/export?` + filter;

    url = `${API_URLBLAZE}/transaction/transaction-report/wallet-ledger/export?` + filter;

    console.log(url);
    return this.http.get(url).pipe(catchError(this.handleError()));
  }


  private handleError<T>(operation = 'operation', result?: T) {
    return (error: HttpErrorResponse): Observable<T> => {
      if (error.status == 401) {
        this.storageService.clean()
        this.router.navigate(['/auth/login']);
      }
      result = error?.error;
      return of(result as T);
    };
  }

  getMerchantWithdrawlReport(status: String,page_size: number, page_no: number, registeredMobile: string) {
    var url = "";
    var filter = "";
    if (status != "" && status != null) {
      filter = filter + `&status=${status}`
    }
    if (registeredMobile != "" && registeredMobile != null) {
      filter = filter + `&registeredMobile=${registeredMobile}`
    }
    filter += '&sort_column=CREATE_DATE';
    filter += '&sort_dir=DESC';

    url = `${API_URLBLAZE}/transaction/transaction-report/merchantWithdrawals?page_size=${page_size}&page_no=${page_no}` + filter;
    console.log(url);
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  cancelMerchantWithdrawl(txnId: string) {
    const url = `${API_URLBLAZE}/transaction/transact/cancel-self-bank-transfer?txnId=${txnId}`;
    console.log(url);

    return this.http.post(url, {}).pipe(
      catchError(this.handleError())
    );
  }
  completeMerchantWithdrawl(request:any) {
    const url = `${API_URLBLAZE}/transaction/transact//complete-self-bank-transfer`;

    return this.http.post(url, request).pipe(
      catchError(this.handleError())
    );
  }












getRemittanceTransfers(search: any, limit: number, page: number, status: string) {

  return this.http.get(
    environment.API_URL +"/transaction/remittance/transfers",
    { params: {search,limit,page,status}
  });

}


validateRemittanceExport(transactionIds: string[]) {

  return this.http.post(environment.API_URL +"/transaction/remittance/transfers/validate",
    transactionIds
  );

}


exportRemittance(transactionIds: string[]) {
  return this.http.post(
    environment.API_URL +
    "/transaction/remittance/export",
    transactionIds
  );

}


downloadRemittanceFile(fileId: string) {

  return this.http.get(
    environment.API_URL +
    "/transaction/remittance/export/download?path=" + fileId,
    {
      responseType: "blob"
    }
  );

}


getExportHistory(search: any, limit: number, page: number) {

  return this.http.get(
    environment.API_URL +
    "/transaction/remittance/export/history",
    {
      params: {
        search,
        limit,
        page
      }
    }
  );

}


resendExportNotification(sequence: string) {

  return this.http.post(
    environment.API_URL +"/transaction/remittance/export/" +sequence +"/resend",
    {}
  );

}

 getAllMerchantMoroccanBank(id :string) {
   const params = new HttpParams().set('id', id.toString());
    var url = `${API_URLBLAZE}/user/merchant/merchant-moroccan-bank`;
    console.log(url);
    return this.http.get(url, { params }).pipe(catchError(this.handleError()));
  }
}